// @mui
import { Box, Container, Stack } from '@mui/material';
// components
import { ConatctHero, ConatctMap, ConsultForm } from '../../sections/web/contact';
import { Seo } from '../../components/seo';

// ----------------------------------------------------------------------

export default function ContactPage() {
  return (
    <>
      <Seo
        title="Contact ASAP UAE in GCC and India"
        description="Contact ASAP Marketing and Studies Consultancy in Sharjah, UAE or Kuttippuram, Kerala, India by phone, email, WhatsApp or our enquiry form."
        path="/contact-us"
      />

      <Container maxWidth="xl" sx={{ py: { xs: 4, md: 6 } }}>
        <Stack spacing={{ xs: 5, md: 8 }}>
          <ConatctHero title="Contact Us" />

          <ConatctMap />

          {/* The form sits in a comfortable reading width rather than
              stretching the full container. */}
          <Box sx={{ width: '100%', maxWidth: 760, mx: 'auto' }}>
            <ConsultForm
              title="Send us a message"
              subtitle="Fill in the form and our team will get back to you as soon as we can."
            />
          </Box>
        </Stack>
      </Container>
    </>
  );
}
